export const authenticationRoutes = {
  signIn: '/auth/(top:sign-in)'
};
